module.exports = __webpack_public_path__ + "img/3-text.4e62da27.png";